<script setup>
  defineOptions({
    name: "DashboardClaim",
  });
</script>

<template>
  <div v-if="$page.props.can.is_education" class="place-content-center px-4">
    <h2 class="text-4xl font-bold text-mcred">MediCheck</h2>
    <h1 class="text-4xl font-bold">Education</h1>
  </div>

  <div v-else class="place-content-center px-4">
    <p class="text-2xl">Willkommen auf Ihrem</p>
    <h2 class="mr-2 inline-block text-4xl font-bold text-mcred">AMTS</h2>
    <h1 class="inline-block text-4xl font-bold">Dashboard</h1>
  </div>
</template>
